import { render, staticRenderFns } from "./scaleio.vue?vue&type=template&id=4b37dd42&"
import script from "./scaleio.vue?vue&type=script&lang=js&"
export * from "./scaleio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports